import React, { useState, useEffect } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { enquiry } from '../../../helper/api_url';
import { formatDate } from '../../../helper/formatDate';
import { swal } from '../../../helper/swal';

export function FollowUpHistoryModal({ enquiryId, schoolName, children }) {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [history, setHistory] = useState([]);

    const toggleModal = () => {
        setShow(!show);
    };

    useEffect(() => {
        if (show && enquiryId) {
            setLoading(true);
            enquiry.fetchSingle(enquiryId)
                .then(res => {
                    const enquiryData = res.data?.enquiry;
                    if (enquiryData && enquiryData.followups) {
                        // Sort by created_at descending (latest first)
                        const sortedFollowups = [...enquiryData.followups].sort(
                            (a, b) => new Date(b.created_at) - new Date(a.created_at)
                        );
                        setHistory(sortedFollowups);
                    } else {
                        setHistory([]);
                    }
                })
                .catch(err => {
                    swal.error(err.response?.data?.message || err.message || "Failed to load follow-up history");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [show, enquiryId]);

    return (
        <>
            {children ? (
                <div onClick={toggleModal} style={{ cursor: 'pointer' }}>{children}</div>
            ) : (
                <button onClick={toggleModal} className='btn btn-sm btn-soft-info me-1' title="Follow Up History">
                    <i className="ri-message-3-line" />
                </button>
            )}
            <Modal className="fade" centered={true} show={show} onHide={toggleModal} size="md">
                <Modal.Header closeButton className="bg-light p-3">
                    <Modal.Title className="fs-15">
                        <i className="ri-chat-history-line align-bottom text-primary me-2"></i>
                        History to {schoolName || "Candidate"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{ maxHeight: '450px', overflowY: 'auto' }}>


                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" role="status" size="sm">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                            <p className="text-muted fs-13 mt-2">Loading follow up records...</p>
                        </div>
                    ) : history.length > 0 ? (
                        <div className="verti-timeline-wrapper">
                            <ul className="verti-timeline list-unstyled border-start border-3 border-dashed border-light ms-2 ps-3" style={{ position: 'relative' }}>
                                {history.map((item, index) => {
                                    const statusColors = {
                                        pending: "warning",
                                        completed: "success",
                                        deleted: "danger",
                                        postpond: "info",
                                        other: "secondary"
                                    };
                                    const badgeColor = statusColors[item.status] || "secondary";

                                    return (
                                        <li key={index} className="mb-4 position-relative" style={{ listStyle: 'none' }}>
                                            {/* Timeline dot */}
                                            <div className="position-absolute" style={{ left: '-27px', top: '2px' }}>
                                                <span className={`avatar-xs d-flex align-items-center justify-content-center bg-white rounded-circle border border-2 border-${badgeColor}`} style={{ width: '18px', height: '18px' }}>
                                                    <span className={`bg-${badgeColor} rounded-circle`} style={{ width: '8px', height: '8px' }}></span>
                                                </span>
                                            </div>

                                            <div className="bg-light p-3 rounded border border-light">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <span className="text-muted fs-11 fw-medium">
                                                        <i className="ri-calendar-event-line me-1 align-bottom"></i>
                                                        {formatDate(item.created_at)}
                                                    </span>
                                                    <span className={`badge badge-soft-${badgeColor} text-capitalize fs-10 px-2`}>
                                                        {item.status === 'deleted' ? 'Not Interested' : item.status}
                                                    </span>
                                                </div>
                                                <p className="text-dark fs-12 mb-2 fw-normal" style={{ whiteSpace: 'pre-wrap' }}>
                                                    {item.remark || <em className="text-muted">No remarks.</em>}
                                                </p>
                                                {item.joining_date && (
                                                    <div className="border-top border-light-2 pt-2 mt-2 d-flex align-items-center justify-content-between">
                                                        <span className="text-muted fs-10">Next Follow-Up Date:</span>
                                                        <span className="text-info fs-11 fw-medium">
                                                            {formatDate(item.joining_date)}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ) : (
                        <div className="text-center py-5 bg-light rounded border border-dashed">
                            <i className="ri-message-3-line text-muted fs-32"></i>
                            <p className="text-muted fs-13 mt-2 mb-0">No past follow ups found for this candidate.</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light p-2">
                    <button type="button" className="btn btn-light btn-sm" onClick={toggleModal}>Close</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
